'use strict';

import storage from '@/core/storage'

const MENU_KEY = 'layout:slide-menu'

const enabled = storage.get(MENU_KEY)

var layoutMdl = angular.module('layoutMdl');

layoutMdl.controller('layoutCtrl', layoutCtrl);

layoutCtrl.$inject = ['$scope'];
function layoutCtrl($scope) {

    $scope.menuLateral = true;
    $scope.menu = menu;

    function menu(aberto) {

        storage.set(MENU_KEY, aberto)

        $scope.menuLateral = aberto;

        if (aberto) {

            // Volta o menu para a posição inicial
            $("#sidebar").animate({ "left": "0" }, "slow");

        } else {

            // Esconde o menu
            $("#sidebar").animate({ "left": "-350px" }, "slow");

        }
    }

    $scope.$on('layout.alternar-menu', function (event, situacao) {
        $scope.menu(situacao);
    });

    $scope.$on('layout.alternar-menu.exibir', function () {
        $scope.menu(true);
    });

    $scope.$on('layout.alternar-menu.esconder', function () {
        $scope.menu(false);
    });

    $scope.$broadcast('layout.alternar-menu', enabled == null ? true : enabled )

}


// WEBPACK FOOTER //
// ./src/modules/layout/layout-controller.js